import axios from "axios";
import { API_BASE } from "./api";

// Portal do Colaborador usa token próprio (não colide com admin/cliente).
export const TALENT_TOKEN_KEY = "cm_talent_token";
export const TALENT_DATA_KEY = "cm_talent_me";
const PREFIX = "/public/talent-portal";

export const talentPortalApi = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

talentPortalApi.interceptors.request.use((config) => {
  const tok = localStorage.getItem(TALENT_TOKEN_KEY);
  if (tok) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${tok}`;
  }
  return config;
});

talentPortalApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(TALENT_TOKEN_KEY);
      localStorage.removeItem(TALENT_DATA_KEY);
      const p = window.location.pathname;
      if (p.startsWith("/portal-colaborador") && p !== "/portal-colaborador") {
        window.location.href = "/portal-colaborador";
      }
    }
    return Promise.reject(error);
  },
);

export const talentApi = {
  login: (email, password) => talentPortalApi.post(`${PREFIX}/login`, { email, password }),
  setPassword: (email, phone, password) =>
    talentPortalApi.post(`${PREFIX}/set-password`, { email, phone, password }),
  me: () => talentPortalApi.get(`${PREFIX}/me`),
  update: (payload) => talentPortalApi.patch(`${PREFIX}/me`, payload),
  cancel: () => talentPortalApi.post(`${PREFIX}/cancel`, {}),
};

export function setTalentSession(token, talent) {
  localStorage.setItem(TALENT_TOKEN_KEY, token);
  if (talent) localStorage.setItem(TALENT_DATA_KEY, JSON.stringify(talent));
}

export function getTalentCached() {
  try {
    const raw = localStorage.getItem(TALENT_DATA_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function talentLogout() {
  localStorage.removeItem(TALENT_TOKEN_KEY);
  localStorage.removeItem(TALENT_DATA_KEY);
}

export function isTalentAuthenticated() {
  return !!localStorage.getItem(TALENT_TOKEN_KEY);
}
